var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67962 2.32038L3.29289 1.70711C3.68342 1.31658 4.31658 1.31658 4.70711 1.70711L7.29289 4.29289C7.68342 4.68342 7.68342 5.31658 7.29289 5.70711L5.50048 7.49952C5.2016 7.7984 5.1275 8.255 5.31653 8.63307C6.40929 10.8186 8.18142 12.5907 10.3669 13.6835C10.745 13.8725 11.2016 13.7984 11.5005 13.4995L13.2929 11.7071C13.6834 11.3166 14.3166 11.3166 14.7071 11.7071L17.2929 14.2929C17.6834 14.6834 17.6834 15.3166 17.2929 15.7071L16.6796 16.3204C14.5683 18.4317 11.2257 18.6693 8.83698 16.8777L7.62857 15.9714C5.88504 14.6638 4.33622 13.115 3.02857 11.3714L2.12226 10.163C0.330722 7.7743 0.568269 4.43173 2.67962 2.32038Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c66100823b3751e1a3b562af95856d88.svg";
export { ForwardRef as ReactComponent };